import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// mui
import { Box, Tabs, Tab, MenuItem, Select, Typography, Stack, Tooltip } from '@mui/material';
// component
import MasterDataGrid from './MasterDataGrid';

// ---------------------------------------------------------------------------------------------------------------

MasterTabPanel.propTypes = {
    columns: PropTypes.array,
    rows: PropTypes.array,
    importHistoryColumns: PropTypes.array,
    importHistoryRows: PropTypes.array,
    masterName: PropTypes.string,
    menuName: PropTypes.string,
    loading: PropTypes.bool,
    importHistoryLoading: PropTypes.bool,
    noOfRecords: PropTypes.number,
    setNoOfRecords: PropTypes.func,
};

TabPanel.propTypes = {
    children: PropTypes.object,
    value: PropTypes.number,
    index: PropTypes.number,
};
// ---------------------------------------------------------------------------------------------------------

const fetchCount = [
    { value: 100, name: '100' },
    { value: 500, name: '500' },
    { value: 1000, name: '1000' },
    { value: 0, name: 'All' },
];

export default function MasterTabPanel({ loading, columns, rows, importHistoryColumns, importHistoryRows,
    masterName, menuName, noOfRecords, setNoOfRecords, importHistoryLoading }) {
    const navigate = useNavigate();

    const [lastUpdatedDate, setLastUpdatedDate] = useState(null);
    const [masterDataCount, setMasterDataCount] = useState(0);
    const [value, setValue] = useState(0);
    const [rowData, setRowData] = useState([]);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        setRowData(rows);
        setLoading(loading);
    }, [rows, loading])

    const handleTabs = (e, val) => {
        setValue(val);
    }

    const handleFetchCount = (event) => {
        setLoading(true);
        setNoOfRecords(event.target.value);

    }

    useEffect(() => {

        setValue(0);
        // Get Latest Master Import Track

    }, []);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', pl: 2 }}>
                <Tabs value={value} onChange={handleTabs} >
                    <Tab label="Current Data" sx={{ px: 2 }} />

                    <Box sx={{ position: 'absolute', right: 16, top: 4 }}>
                        <Stack direction='row' alignItems='center' justifyContent='flex-end' spacing={1}>
                            <Typography variant='subtitle1' sx={{ display: { xs: 'none', md: 'block' } }}>
                                Fetch Records
                            </Typography>
                            <Tooltip title='Fetch Records' placement="top">
                                <Select name="noOfRecords" label="" size='small' value={noOfRecords}
                                    sx={{ width: 85 }} onChange={handleFetchCount}>
                                    {fetchCount.map((count) => (
                                        <MenuItem key={count.value} value={count.value}>
                                            {count.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Tooltip>
                            <Tooltip title='Total Records'>
                                <Typography variant='subtitle1'>
                                    /{masterDataCount}
                                </Typography>
                            </Tooltip>
                        </Stack>
                    </Box>
                </Tabs>
            </Box>
            <TabPanel value={value} index={0} >
               
                    <MasterDataGrid loading={isLoading} columnData={columns} rowData={rowData} masterName={masterName} lastUpdatedDate={lastUpdatedDate} />
            </TabPanel>

           

        </Box>
    );
}
// ---------------------------------------------------------------------------------------------------------

function TabPanel(props) {
    const { children, value, index } = props;
    return (
        <div> {value === index && <div>  {children}  </div>}  </div>
    )
}